// extracted by mini-css-extract-plugin
export default {"tradingPage":"TradingPage_tradingPage__so6NM"};